const getRelativeCoordinatesWithScroll = (childElement, parentElement) => {
	const childRect = childElement.getBoundingClientRect();
	const parentRect = parentElement.getBoundingClientRect();

	// Учитываем scroll родителя
	const parentScrollTop = parentElement.scrollTop || 0;

	const relativeY = childRect.top - parentRect.top + parentScrollTop;

	return {
		y: relativeY,
		height: childRect.height,
	};
};

const filterForm = document.querySelector('.js-catalog-filters-form');
const floatBtn = document.querySelector('.js-catalog-filter-float-btn');

export const floatBtnHandler = ({ target }) => {
	if (window.innerWidth < 1000 || !floatBtn || !filterForm || !target) return;

	let parentEl = null;
	const isRangeInput =
		target.classList.contains('catalog__range-thumb') ||
		target.classList.contains('js-range-input-min') ||
		target.classList.contains('js-range-input-max');

	const isCheckbox = target.classList.contains('js-catalog-filter-checkbox');

	const isInStockBtn = Boolean(target.closest('.catalog-products__filter-in-stock'));

	if (isCheckbox) {
		parentEl = target.closest('.js-catalog-filter-item');
		const { y, height } = getRelativeCoordinatesWithScroll(parentEl, filterForm);
		floatBtn.style.top = `${y - height}px`;
		floatBtn.classList.remove('hidden');
	} else if (isRangeInput) {
		parentEl = target.closest('.js-catalog-range');
		const { y } = getRelativeCoordinatesWithScroll(parentEl, filterForm);
		floatBtn.style.top = `${y}px`;
		floatBtn.classList.remove('hidden');
	} else if (isInStockBtn) {
		parentEl = target.closest('.catalog-products__filter-in-stock');
		const { y } = getRelativeCoordinatesWithScroll(parentEl, filterForm);
		floatBtn.style.top = `${y}px`;
		floatBtn.classList.remove('hidden');
	}
};
